import React from 'react';
import { Button } from 'antd';
import CommonListsIndex from '../../components/CommonLists/index';
import PicturesList from './list';
import PicturesAdd from './add';

class Pictures extends CommonListsIndex {
  constructor(props) {
    super(props);
    this.api = 'pictures';
    this.addComponent = ``;
    this.editComponent = ``;
    this.listsComponent = PicturesList;
  }
  componentDidMount() {
    this.editComponent = PicturesAdd;
    this.addComponent = PicturesAdd;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.adsId !== '' && nextProps.adsId !== this.props.adsId) {
      this.queryList({ adsId: nextProps.adsId });
    }
  }

  freshQueryList = () => {
    this.queryList({ adsId: this.props.adsId });
  };

  render() {
    const ListsComponent = this.listsComponent;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <ListsComponent
          data={this.state.listsData}
          edit={this.edit}
          queryList={this.freshQueryList}
        />
      </div>
    );
  }
}
export default Pictures;
